// extracted by mini-css-extract-plugin
module.exports = {"root":"ExhibitionCard_root__VCfzk","flip":"ExhibitionCard_flip__ZmaCO","text":"ExhibitionCard_text__s9MKZ"};